import React, { useEffect, useState } from "react";
import ItemRequest_Breadcrumbs from "./ItemRequest_Breadcrumbs";
import { useNavigate } from "react-router-dom";
import "./ItemRequest.css";
import FilterModal from "./component/FilterModal";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  ITEMSREQASummaryAPI,
  summaryGridColumn,
} from "./ItemCreationRequestAction";
import { useDispatch, useSelector } from "react-redux";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { Head_Set } from "./SliceItemCreationRequest";
import moment from "moment";

const ItemRequestSummary = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setShowOpen] = useState(false);
  const handleClose = () => setShowOpen(false);
  const status = ["ALL", "ENTER", "POST", "APPROVE"];

  const [summaryData, setSummaryData] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const filterObj = useSelector(
    (state) => state.SliceItemCreationRequest.value.filterObj
  );
  const LocWithoutRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const fItemRequestSummary = async () => {
    const Obj = {
      startDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      endDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      location:
        filterObj?.loc === "" ? LocWithoutRights[0]?.Uid : filterObj?.loc,
      status: filterObj?.status,
      UserCd: vRdxuserInfo.UserID,
    };
    let response = await ITEMSREQASummaryAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet?.length > 0) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSummaryData(GridID);
      handleClose();
    } else {
      handleClose();
      setSummaryData([]);
    }
  };

  const fNew = () => {
    dispatch(
      Head_Set({
        A_Id: 0,
        A_Date: new Date(),
        A_Loc: LocWithoutRights[0]?.Uid,
        A_LocName: LocWithoutRights[0]?.Name1,
        A_Narr: "",
        A_Status: "ENTER",
        A_Confirm_Status: "ENTER",
      })
    );
    navigate("/ItemCreationRequest");
    setTimeout(() => {
      document.getElementById("transDate")?.focus();
    }, 500);
  };

  const handleRowClick = (rowData) => {
    dispatch(
      Head_Set({
        A_Id: rowData.row.A_Id,
        A_Date: rowData.row.A_Date,
        A_Loc: rowData.row.A_Loc,
        A_LocName: rowData.row.A_LocName,
        A_Narr: rowData.row.A_Narr,
        A_Status: rowData.row.A_Status,
        A_Confirm_Status: rowData.row.A_Confirm_Status,
      })
    );
    navigate("/ItemCreationRequest");
    setTimeout(() => {
      document.getElementById("transDate")?.focus();
    }, 500);
  };

  useEffect(() => {
    fItemRequestSummary();
  }, []);

  return (
    <div className=" my-3 ">
      <Grid container spacing={0}>
        <Grid item xs={7.5} sm={6} md={6} className="Breadcrumbs d-flex">
          <ItemRequest_Breadcrumbs />
        </Grid>
        <Grid
          item
          xs={4}
          sm={6}
          md={6}
          sx={{
            display: "flex",
            textAlign: vMediaQuery ? "" : "right",
            justifyContent: vMediaQuery ? "" : "right",
            gap: "8px",
          }}
        >
          <Button
            variant="contained"
            size={vMediaQuery ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              padding: vMediaQuery ? 0 : "8px 20px",
              height: vMediaQuery ? "25px" : "35px",
            }}
            onClick={() => {
              setShowOpen(true);
            }}
          >
            Filter
          </Button>

          <Button
            variant="contained"
            size={vMediaQuery ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              padding: vMediaQuery ? 0 : "8px 20px",
              height: vMediaQuery ? "25px" : "35px",
            }}
            onClick={fNew}
          >
            New
          </Button>
        </Grid>
      </Grid>
      <div></div>
      <div className="ItemRequest-head pt-4">
        <Box style={{ height: "70vh", width: "100%" }}>
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            height={20}
            getRowId={(row) => row.id}
            rows={summaryData}
            columns={summaryGridColumn}
            experimentalFeatures={{ newEditingApi: false }}
            hideFooter={summaryData.length < 100}
            onRowClick={handleRowClick}
            components={{
              Toolbar: true ? "" : GridToolbar,
            }}
          />
        </Box>
      </div>

      <FilterModal
        open={open}
        handleClose={handleClose}
        status={status}
        LocWithoutRights={LocWithoutRights}
        filterObj={filterObj}
        vMediaQuery={vMediaQuery}
        itemRequestSummary={fItemRequestSummary}
      />
    </div>
  );
};

export default ItemRequestSummary;
